export default {
  apiPath: "https://api.snphotography.com.au"
}